export default __webpack_public_path__ + "static/media/cn.890ef6a6.svg";